import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import CountUp from '@/components/CountUp';
import { formatBRL } from '@/lib/format';

interface Props {
  label: string;
  /** se valor é número, faz count-up animado. Se ReactNode, exibe direto. */
  valor: ReactNode | number;
  /** se setado, formata count-up como BRL (R$ 1.234,56) */
  moeda?: boolean;
  delta?: { sinal: '+' | '-'; texto: string };
  hint?: string;
  className?: string;
}

export function KPITile({ label, valor, moeda = false, delta, hint, className }: Props) {
  const conteudo: ReactNode =
    typeof valor === 'number'
      ? moeda
        ? <CountUp to={valor} format={(n) => formatBRL(n)} duration={900} />
        : <CountUp to={valor} duration={700} />
      : valor;
  return (
    <div
      className={cn(
        'relative bg-panel border border-[var(--border)] rounded-md p-s5 overflow-hidden',
        className,
      )}
      style={{ boxShadow: 'inset 0 1px 0 rgba(236,235,227,0.04), 0 1px 2px rgba(0,0,0,0.4)' }}
    >
      <div className="t-overline">{label}</div>
      <div className="font-display text-[40px] leading-none tracking-[-0.03em] text-fg-1 mt-s3 tnum">
        {conteudo}
      </div>
      <div className="flex items-baseline justify-between mt-s3">
        {delta && (
          <span
            className={cn(
              'font-mono text-[11px]',
              delta.sinal === '+' ? 'text-moss-300' : 'text-petal-300',
            )}
          >
            {delta.sinal}
            {delta.texto}
          </span>
        )}
        {hint && <span className="font-body text-[11px] text-fg-3">{hint}</span>}
      </div>
    </div>
  );
}

export default KPITile;
